/**
 * Action types for alarms report functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle alarms report list.
 */

// Get alarms report constants
export const GET_ALARMS_REPORT = 'GET_ALARMS_REPORT';
export const ALARMS_REPORT_REQUEST_GET = 'ALARMS_REPORT_REQUEST_GET';
export const ALARMS_REPORT_RESPONSE_GET_SUCCESS = 'ALARMS_REPORT_RESPONSE_GET_SUCCESS';
export const ALARMS_REPORT_RESPONSE_GET_FAIL = 'ALARMS_REPORT_RESPONSE_GET_FAIL';

// Get alarms KPI report constants
export const KPI_GET_ALARMS_REPORT = 'KPI_GET_ALARMS_REPORT';
export const KPI_ALARMS_REPORT_REQUEST_GET = 'KPI_ALARMS_REPORT_REQUEST_GET';
export const KPI_ALARMS_REPORT_RESPONSE_GET_SUCCESS = 'KPI_ALARMS_REPORT_RESPONSE_GET_SUCCESS';
export const KPI_ALARMS_REPORT_RESPONSE_GET_FAIL = 'KPI_ALARMS_REPORT_RESPONSE_GET_FAIL'

// Add alarms kpi reports constants
export const REPORTS_REQUEST_ADD = 'REPORTS_REQUEST_ADD';
export const REPORTS_RESPONSE_ADD_FAIL = 'REPORTS_RESPONSE_ADD_FAIL';
export const REPORTS_RESPONSE_ADD_SUCCESS = 'REPORTS_RESPONSE_ADD_SUCCESS';
export const RESET_REPORTS_ADD = 'RESET_REPORTS_ADD';
export const REPORT_ADDED_SUCCESFULLY = 'REPORT_ADDED_SUCCESFULLY';
export const REPORT_ADD_SUCCESS_MESSAGE = 'REPORT_ADD_SUCCESS_MESSAGE';

// Delete alarms report constants
export const REPORT_DELETE_REQUEST = 'REPORT_DELETE_REQUEST';
export const REPORT_DELETE_SUCCESS = 'REPORT_DELETE_SUCCESS';
export const REPORT_DELETE_FAIL = 'REPORT_DELETE_FAIL';
export const RESET_REPORT_DELETE = 'RESET_REPORT_DELETE';

// Download report 
export const REPORT_DOWNLOAD_REQUEST_ADD = 'REPORT_DOWNLOAD_REQUEST_ADD';
export const REPORT_CREATION_INITIATED = 'REPORT_CREATION_INITIATED';
export const REPORT_DOWNLOAD_RESPONSE_ADD_SUCCESS = 'REPORT_DOWNLAOD_RESPONSE_ADD_SUCCESS';
export const REPORT_DOWNLAOD_RESPONSE_ADD_FAIL = 'REPORT_DOWNLOAD_RESPONSE_ADD_FAIL';
export const REPORT_DOWNLAOD_ADD_SUCCESS_MESSAGE = 'Report downloaded successfully';

// Dowload report status check

export const REPORT_DOWNLOAD_STATUS_REQUEST_GET = 'REPORT_DOWNLOAD_STATUS_REQUEST_GET';
export const REPORT_DOWNLOAD_STATUS_RESPONSE_GET_SUCCESS = 'REPORT_DOWNLOAD_STATUS_RESPONSE_GET_SUCCESS';
export const REPORT_DOWNLOAD_STATUS_RESPONSE_GET_FAIL = 'REPORT_DOWNLOAD_STATUS_RESPONSE_GET_FAIL';

// Dowload report credated downlaod

export const REPORT_CREATED_DOWNLOAD_REQUEST_GET = 'REPORT_CREATED_DOWNLOAD_REQUEST_GET';
export const REPORT_CREATED_DOWNLOAD_RESPONSE_GET_SUCCESS = 'REPORT_CREATED_DOWNLOAD_RESPONSE_GET_SUCCESS';
export const REPORT_CREATED_DOWNLOAD_RESPONSE_GET_FAIL = 'REPORT_CREATED_DOWNLOAD_RESPONSE_GET_FAIL';

// Edit Reprot 

export const GET_EDIT_ALARMS_REPORT = 'GET_EDIT_ALARMS_REPORT';
export const EDIT_ALARMS_REPORT_REQUEST_GET = 'EDIT_ALARMS_REPORT_REQUEST_GET';
export const EDIT_ALARMS_REPORT_RESPONSE_GET_SUCCESS = 'EDIT_ALARMS_REPORT_RESPONSE_GET_SUCCESS';
export const EDIT_ALARMS_REPORT_RESPONSE_GET_FAIL = 'EDIT_ALARMS_REPORT_RESPONSE_GET_FAIL'

// edit active alarms reports constants
export const REPORTS_REQUEST_EDIT = 'REPORTS_REQUEST_EDIT';
export const REPORTS_RESPONSE_EDIT_FAIL = 'REPORTS_RESPONSE_EDIT_FAIL';
export const REPORTS_RESPONSE_EDIT_SUCCESS = 'REPORTS_RESPONSE_EDIT_SUCCESS';
export const REPORT_UPDATED_SUCCESFULLY = 'REPORT_UPDATED_SUCCESFULLY';
export const REPORT_EDIT_SUCCESS_MESSAGE = 'REPORT_EDIT_SUCCESS_MESSAGE';

// add pre-defined report
export const REPORT_REQUEST_ADD = 'REPORT_REQUEST_ADD';
export const REPORT_ADDED_SUCCESSFULLY = "REPORT_ADDED_SUCCESSFULLY";
export const REPORT_RESPONSE_ADD_SUCCESS = 'REPORT_RESPONSE_ADD_SUCCESS';
export const REPORT_RESPONSE_ADD_FAIL = 'REPORT_RESPONSE_ADD_FAIL';
